module.exports = __webpack_public_path__ + "img/header-diamondJewelry.859a898.jpg";